import React, { useCallback } from "react";

import { useIntl } from "react-intl";

import Funnel from "@mapmycustomers/shared/types/entity/deals/Funnel";

import SelectField from "@app/component/input/SelectField";
import useSelectFieldOptions from "@app/util/hook/useSelectFieldOptions";

import styles from "./FunnelSelectBar.module.scss";

interface Props {
  funnels: Funnel[];
  onChange?: (funnel: Funnel | undefined) => void;
  value: Funnel | undefined;
}

const FunnelSelectBar: React.FC<Props> = ({ funnels, onChange, value }) => {
  const intl = useIntl();
  const options = useSelectFieldOptions(funnels);
  const handleChange = useCallback(
    (funnelId: Funnel["id"]) => {
      onChange?.(funnels.find(({ id }) => id === funnelId));
    },
    [funnels, onChange]
  );
  return (
    <div className={styles.container}>
      <SelectField<Funnel["id"]>
        className={styles.select}
        label={intl.formatMessage({
          id: "reports.deals.funnel.header",
          defaultMessage: "Funnel",
          description: "Title of funnels in deal section",
        })}
        labelClassName={styles.label}
        onChange={handleChange}
        options={options}
        value={value ? value.id : undefined}
      />
    </div>
  );
};

export default FunnelSelectBar;
